import { Box, Grid, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { KPP_TERMS } from '../../../../lib/constants';
import { addLineBreaks } from '../../../../utils/formatString';
import { GenericButton } from '../../../GenericButton/GenericButton';
import {
	useStyles,
	getImageSrc,
	InfoChartTabType,
	InfoChartTerm,
} from './InfoChart';

interface Props {
	term: InfoChartTerm;
	setTerm: (newTerm: InfoChartTerm) => void;
}

export const InfoChartSingle: React.FC<Props> = ({ term, setTerm }) => {
	const classes = useStyles();
	const { t } = useTranslation();

	const [imageSrc, setImageSrc] = useState(
		getImageSrc(term, InfoChartTabType.SINGLE)
	);

	useEffect(() => {
		setImageSrc(getImageSrc(term, InfoChartTabType.SINGLE));
	}, [term]);

	return (
		<>
			<Typography variant="h3">
				{addLineBreaks(
					t('quickMenu.info.chart.single.subtitle', { months: term })
				)}
			</Typography>
			<Box py={2}>{imageSrc}</Box>
			<Grid container spacing={2} >
				<Grid item xs={12} sm={6}  style={{  flexBasis: "72%", maxWidth: "72%" }}>
					<Box p={2} className={classes.inputBox}>
						<Typography variant="h3" gutterBottom>
							{t('quickMenu.info.chart.single.coveragePeriod')}
						</Typography>
						<Grid container spacing={1}>
							{KPP_TERMS.map((tm) => (
								<Grid key={tm} item className={classes.stretchButton}>
									<GenericButton
										onClick={() => setTerm(tm)}
										fullWidth
										color={term === tm ? 'primary' : 'default'}
									>
										{`${tm} ${t('kppTerm.months')}`}
									</GenericButton>
								</Grid>
							))}
						</Grid>
					</Box>
				</Grid>
			</Grid>
		</>
	);
};
